<template>
  <el-select
    :value="value"
    filterable
    remote
    reserve-keyword
    :multiple="multiple"
    :clearable="clearable"
    :collapse-tags="collapseTags"
    :placeholder="$t('90')"
    :remote-method="supRemoteMethod"
    :loading="supLoading"
    @change="handlerChange"
  >
    <el-option v-for="item in supOptions" :key="item.staff_id" :label="item.staff_name" :value="item.staff_id">
    </el-option>
  </el-select>
</template>

<script>
// 获取在职状态
import { searchStaffFn } from 'api/org/per'

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String, Array],
      default: ''
    }
  },
  data() {
    return {
      timer: null,
      supLoading: false,
      supOptions: [] // 可选项
    }
  },
  methods: {
    supRemoteMethod(query) {
      if (query !== '') {
        this.supLoading = true
        // ajax请求
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          searchStaffFn({
            search_name: query,
            page_size: 20
          }).then(res => {
            this.supLoading = false
            if (res && res.code === 1) {
              this.supOptions = res.data.map(v => ({
                staff_name: v.staff_name,
                staff_id: v.staff_id
              }))
            }
          })
        }, 300)
      } else {
        this.supOptions = []
      }
    },
    handlerChange(v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style></style>
